const note = {
    version: '1.0.0',
    date: '2026-08-26',
    tags: ['Nyt', 'Forbedret'],
    body: `
- **Hurtigere søgning efter matters.** Søgefeltet finder nu en matter på flere ord i navnet og ikke kun på begyndelsen.
- **De sidst brugte matters er med det samme.** Dem, du har arbejdet på for nylig, ligger klar i listen.
- **Select all.** Filtrene i kalenderen har fået select all, så en hel gruppe kan slås til eller fra i ét klik.
- **Delegerede kalendere bliver stående.** Kalendere, du har fået adgang til, forsvandt, når siden blev genindlæst.
`,
};

export default note;
